<template>
  <img
    alt="Microsoft Business Central logo"
    src="../assets/BusinessCentral.svg"
  >
</template>
